import * as React from 'react'

import Localization from '~/client/src/shared/localization/LocalizationManager'

import FullScreenPickerSheet from '../FullScreenPickerSheet/FullScreenPickerSheet'
import { ListSelector } from '../ListSelector/ListSelector'
import StruxhubAttributeSelector from '../StruxhubInputs/StruxhubSelector/StruxhubAttributeSelector'
import LocationResourcePicker from './LocationResourcePicker'

export interface ILocationPickerFieldProps {
  label: string
  /** Shown behind an info icon beside the label. */
  labelTooltip?: string
  selectedId?: string | null
  /** Called only when a different location is picked. */
  onSelect: (id: string) => void
  /** Omit to drop the field's reset icon. */
  onReset?: () => void
  excludedSubtreeOf?: string | null
  isRequired?: boolean
  isReadOnly?: boolean
  isDisabled?: boolean
  isValid?: boolean
  validationMessage?: string
  isHelperTextHidden?: boolean
  isTopMarginForced?: boolean
  className?: string
}

const LocationPickerField: React.FC<ILocationPickerFieldProps> = ({
  label,
  selectedId,
  onSelect,
  onReset,
  excludedSubtreeOf,
  isValid = true,
  ...triggerProps
}) => {
  const [isPickerOpen, setIsPickerOpen] = React.useState(false)
  const closePicker = () => setIsPickerOpen(false)

  return (
    <>
      <StruxhubAttributeSelector
        {...triggerProps}
        label={label}
        isValid={isValid}
        value={selectedId || ''}
        onClick={() => setIsPickerOpen(true)}
        onValueReset={onReset}
      />
      <FullScreenPickerSheet isOpen={isPickerOpen} onClose={closePicker}>
        <ListSelector.Title
          title={Localization.translator.selectX(label)}
          onClose={closePicker}
        />
        <div className="tw:flex-1 tw:min-h-0">
          <LocationResourcePicker
            mode="single"
            selectedIds={selectedId ? [selectedId] : []}
            excludedSubtreeOf={excludedSubtreeOf}
            onSelect={([id]) => {
              closePicker()
              if (id && id !== selectedId) onSelect(id)
            }}
            onClose={closePicker}
          />
        </div>
      </FullScreenPickerSheet>
    </>
  )
}

export default LocationPickerField
